import React from 'react';

function SmartDetailCard(props) {
  return (
    <>
      <div className='display-flex   product-detail-line-item' style={{borderTopRightRadius: 10}}>
        <p className='detail-name'>Business Name </p>
        <p>{props?.product?.agriBusinessName || props?.product?.businessName}</p>
      </div>
      <div className='display-flex   product-detail-line-item' style={{borderTopRightRadius: 10}}>
        <p className='detail-name'>City Name </p>
        <p>{props?.product?.city || props?.product?.cityName}</p>
      </div>
      <div className='display-flex   product-detail-line-item' style={{borderTopRightRadius: 10}}>
        <p className='detail-name'>Contact Person </p>
        <p>{props?.product?.agriBusinessPocContact || props?.product?.contactPerson}</p>
      </div>
      <div className='display-flex   product-detail-line-item' style={{borderTopRightRadius: 10}}>
        <p className='detail-name'>Description </p>
        <p>{props?.product?.description}</p>
      </div>
      <div className='display-flex   product-detail-line-item' style={{borderTopRightRadius: 10}}>
        <p className='detail-name'>Measure </p>
        <p>{props?.product?.qtyName || props?.product?.measure}</p>
      </div>
      <div className='display-flex   product-detail-line-item' style={{borderTopRightRadius: 10}}>
        <p className='detail-name'>Average Weight / Package Size </p>
        <p>{(props?.product?.avgWtSize || 0) + " " + (props?.product?.qtyName || props?.product?.measure)}</p>
      </div>
      <div className='display-flex   product-detail-line-item' style={{borderTopRightRadius: 10}}>
        <p className='detail-name'>Price </p>
        <p>{props?.product?.currency} {props?.product?.priceSetByVendor}</p>
      </div>
      <div className='display-flex   product-detail-line-item' style={{borderTopRightRadius: 10}}>
        <p className='detail-name'>Minimun Quantity </p>
        <p>{props?.product?.moq}</p>
      </div>
    </>
  );
}

export default SmartDetailCard;


export function SmartServiceDetailCard(props) {
  return (
    <>
      <div className='display-flex'>
        <div className='display-flex  justify-content-between product-detail-line-item half-width'
             style={{borderTopRightRadius: 10}}>
          <p className='detail-name'>Service Type </p>
          <p>{props?.product?.agriBusinessName || props?.product?.businessName}</p>
        </div>
        <div className='display-flex  justify-content-between product-detail-line-item   half-width '
             style={{borderTopRightRadius: 10}}>
          <p className='detail-name'>service Range </p>
          <p>{props?.product?.agriBusinessName || props?.product?.businessName}</p>
        </div>
      </div>

      <div className='display-flex'>
        <div className='display-flex  justify-content-between  product-detail-line-item half-width'
             style={{borderTopRightRadius: 10}}>
          <p className='detail-name'>business Name </p>
          <p>{props?.product?.city || props?.product?.cityName}</p>
        </div>
        {/*<div className='display-flex  justify-content-between  product-detail-line-item half-width' style={{borderTopRightRadius: 10}}>*/}
        {/*  /!*<p className='detail-name'>point of contact </p>*!/*/}
        {/*  /!*<p>{props?.product?.agriBusinessPocContact || props?.product?.contactPerson}</p>*!/*/}
        {/*</div>*/}
      </div>

      <div className='display-flex'>
        <div className='display-flex  justify-content-between  product-detail-line-item half-width'
             style={{borderTopRightRadius: 10}}>
          <p className='detail-name'>point of contact </p>
          <p>{props?.product?.agriBusinessPocContact || props?.product?.contactPerson}</p>
        </div>
        <div className='display-flex  justify-content-between  product-detail-line-item half-width'
             style={{borderTopRightRadius: 10}}>
          <p className='detail-name'>contact number </p>
          <p>{props?.product?.qtyName || props?.product?.measure}</p>
        </div>
      </div>

      <div className='display-flex'>
        <div className='display-flex  justify-content-between  product-detail-line-item half-width'
             style={{borderTopRightRadius: 10}}>
          <p className='detail-name'>service charges </p>
          <p>{(props?.product?.avgWtSize || 0) + " " + (props?.product?.qtyName || props?.product?.measure)}</p>
        </div>
        <div className='display-flex  justify-content-between  product-detail-line-item half-width'
             style={{borderTopRightRadius: 10}}>
          <p className='detail-name'>measurement unit </p>
          <p>{props?.product?.currency} {props?.product?.priceSetByVendor}</p>
        </div>
      </div>
      <div className='display-flex'>
        <div
          className='display-flex  justify-content-between   justify-content-between product-detail-line-item half-width'
          style={{borderTopRightRadius: 10}}>
          <p className='detail-name'>quantity </p>
          <p>{(props?.product?.avgWtSize || 0) + " " + (props?.product?.qtyName || props?.product?.measure)}</p>
        </div>
        <div
          className='display-flex  justify-content-between  justify-content-between product-detail-line-item half-width'
          style={{borderTopRightRadius: 10}}>
          <p className='detail-name'>franchies </p>
          <p>{props?.product?.currency} {props?.product?.priceSetByVendor}</p>
        </div>
      </div>

      <div className='display-flex'>
        <div
          className='display-flex  justify-content-between  justify-content-between product-detail-line-item half-width'
          style={{borderTopRightRadius: 10}}>
          <p className='detail-name'>city/state </p>
          <p>{(props?.product?.avgWtSize || 0) + " " + (props?.product?.qtyName || props?.product?.measure)}</p>
        </div>
        <div
          className='display-flex  justify-content-between  justify-content-between product-detail-line-item half-width'
          style={{borderTopRightRadius: 10}}>
          <p className='detail-name'>country </p>
          <p>{props?.product?.currency} {props?.product?.priceSetByVendor}</p>
        </div>
      </div>

      {/*<div className='display-flex    product-detail-line-item full-width' style={{borderTopRightRadius: 10}}>*/}
      {/*  <p className='detail-name'>Agri description </p>*/}
      {/*  <p>{props?.product?.moq}</p>*/}
      {/*</div>*/}
    </>
  );
}
